/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Launcher_CtaInputs */

const en_pc_dl_launcher_cta = /** @type {(inputs: Pc_Dl_Launcher_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get the ArtCraft Launcher`)
};

const zh_pc_dl_launcher_cta = /** @type {(inputs: Pc_Dl_Launcher_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载 ArtCraft Launcher`)
};

/**
* | output |
* | --- |
* | "Get the ArtCraft Launcher" |
*
* @param {Pc_Dl_Launcher_CtaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_launcher_cta = /** @type {((inputs?: Pc_Dl_Launcher_CtaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Launcher_CtaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_launcher_cta(inputs)
	return zh_pc_dl_launcher_cta(inputs)
});
export { pc_dl_launcher_cta as "pc.dl.launcher_cta" }